import { defineMessages } from 'react-intl';

export default defineMessages({
    buildingAndLocationsTitle: {
        id: "quoteandbind.wizard.commercial.TWIA.BuildandLoc",
        defaultMessage: "Buildings & Locations"
    },
    addBuilding: {
        id: "quoteandbind.wizard.commercial.TWIA.BuildingList.Add Building",
        defaultMessage: "Add Building"
    },
    constructionHeading: {
        id: "quoteandbind.wizard.commercial.TWIA.Delete Building",
        defaultMessage: "Delete Building"
    },
    addBuildingToLocation: {
        id: "quoteandbind.wizard.commercial.TWIA.Add Building To Location",
        defaultMessage: "Add Building to this Location"
    },
    locationId: {
        id: "quoteandbind.wizard.commercial.TWIA.LocationID",
        defaultMessage: "LOCATION ID"
    },
    location: {
        id: "quoteandbind.wizard.commercial.TWIA.Locations",
        defaultMessage: "LOCATION"
    },
    buildingId: {
        id: "quoteandbind.wizard.commercial.TWIA.BuildingID",
        defaultMessage: "BUILDING ID"
    },
    buildDesc: {
        id: "quoteandbind.wizard.commercial.TWIA.BuildingDescription",
        defaultMessage: "BUILDING DESCRIPTION"
    },
    coverageForm: {
        id: "quoteandbind.wizard.commercial.TWIA.Coverage Form",
        defaultMessage: "COVERAGE FORM"
    },
    wantToDeleteBuilding: {
        id: "quoteandbind.wizard.commercial.TWIA.Delete Building",
        defaultMessage: "Delete Building"
    },
    deleteMessage: {
        id: "quoteandbind.wizard.commercial.TWIA.Are you sure you want to delete this building?",
        defaultMessage: "Are you sure you want to delete this building?"
    },
    yesModal: {
        id: "quoteandbind.wizard.commercial.TWIA.Yes, please delete",
        defaultMessage: "Yes, please delete"
    },
    closeModal: {
        id: "quoteandbind.wizard.commercial.TWIA.No, I'll keep it",
        defaultMessage: "No, I'll keep it"
    },
})